module.exports = "/_next/static/images/f27957b6d30798fdd66d96313eb4d423-logo-valor-investe.png.webp";